/* PupTailor Halloween 2026 — page-scoped behaviour (loaded only by ph26 sections).
   - Hero height: measures announcement bar + header so the hero fills the first screen.
   - Countdown: refreshes on each minute boundary; hides itself when time is up (never shows 0).
   - Reveal: fade-up once per element; skipped entirely under prefers-reduced-motion.
   - Quick Add / rider add / picker add: POST /cart/add.js, refresh the cart icon; on phones with the haul bar visible the
     add is confirmed in the bar (keep shopping), otherwise Rebuy Smart Cart opens.
   - In-page variant picker: bottom sheet for allow-listed multi-variant products (native Shopify variants only).
   - Mobile haul bar: multi-buy tier (eligible items only) and/or free-shipping gap; appears after the hero; dismissible.
   - Ad match: ?focus=key (or utm_content containing key) retargets the hero's primary button. */
(function () {
  if (window.ph26Loaded) return;
  window.ph26Loaded = true;

  var logoUrl = (document.currentScript && document.currentScript.getAttribute('data-ph26-logo')) || '';

  var root = document.documentElement;
  root.classList.add('ph26-js');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ---------- Hero offset ---------- */
  function setHeroOffset() {
    var hero = document.querySelector('[data-ph26-hero]');
    if (!hero) return;
    // Height of announcement bar + header, used to float them over the hero (see "Transparent header" CSS).
    var chrome = 0;
    document.querySelectorAll('.announcement-bar-section, .section-header').forEach(function (el) { chrome += el.offsetHeight; });
    if (chrome) root.style.setProperty('--ph26-chrome-h', chrome + 'px');
    var top = hero.getBoundingClientRect().top + window.scrollY;
    hero.style.setProperty('--ph26-offset', Math.max(0, Math.round(top)) + 'px');
  }

  /* ---------- Countdown ---------- */
  var countdownTimer = null;

  function renderCountdowns() {
    var now = Date.now();
    document.querySelectorAll('[data-ph26-countdown]').forEach(function (el) {
      var end = Date.parse(el.getAttribute('data-end'));
      if (isNaN(end) || end - now <= 0) {
        el.hidden = true;
        return;
      }
      var secsLeft = Math.floor((end - now) / 1000);
      var mins = Math.floor(secsLeft / 60);
      var values = { d: Math.floor(mins / 1440), h: Math.floor((mins % 1440) / 60), m: mins % 60, s: ('0' + (secsLeft % 60)).slice(-2) };
      el.querySelectorAll('[data-unit]').forEach(function (n) {
        var v = String(values[n.getAttribute('data-unit')]);
        if (n.textContent !== v) {
          var changed = n.textContent !== '';
          n.textContent = v;
          if (changed && !reduceMotion.matches) {
            n.classList.remove('is-tick');
            void n.offsetWidth; // restart the tick animation
            n.classList.add('is-tick');
          }
        }
      });
      el.hidden = false;
    });
  }

  function scheduleCountdown() {
    clearTimeout(countdownTimer);
    renderCountdowns();
    if (!document.querySelector('[data-ph26-countdown]:not([hidden])')) return;
    countdownTimer = setTimeout(scheduleCountdown, 1000 - (Date.now() % 1000) + 20);
  }

  /* ---------- Reveal ---------- */
  var observer = null;

  function initReveal(scope) {
    var items = (scope || document).querySelectorAll('.ph26 [data-ph26-reveal]:not(.is-in)');
    if (reduceMotion.matches || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        var n = 0;
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          // Items that enter together (e.g. a row of cards) fade in one after another.
          entry.target.style.setProperty('--ph26-d', Math.min(n * 90, 450) + 'ms');
          n += 1;
          entry.target.classList.add('is-in');
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -10% 0px' });
    }
    items.forEach(function (el) { observer.observe(el); });
  }

  /* ---------- Cart helpers ---------- */
  var root_url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  var CURRENCY_SYMBOLS = { USD: '$', CAD: 'C$', AUD: 'A$', NZD: 'NZ$', GBP: '£', EUR: '€' };

  function money(cents) {
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    var v = (cents || 0) / 100;
    var str = v % 1 === 0 ? v.toFixed(0) : v.toFixed(2);
    return CURRENCY_SYMBOLS[cur] ? CURRENCY_SYMBOLS[cur] + str : str + ' ' + cur;
  }

  function openCartDrawer() {
    try {
      var R = window.Rebuy;
      if (R && R.SmartCart && typeof R.SmartCart.show === 'function') { R.SmartCart.show(); return; }
    } catch (e) {}
    window.location.href = root_url + 'cart';
  }

  function progressBarShown() {
    var bar = document.querySelector('[data-ph26-progress]');
    // position:fixed elements always have offsetParent === null, so check the computed display instead.
    return !!(bar && !bar.hidden && getComputedStyle(bar).display !== 'none');
  }

  function refreshCartUi(openDrawer) {
    // Theme cart icon count (Dawn cart-icon-bubble section).
    fetch(root_url + '?sections=cart-icon-bubble', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (json) {
        var bubble = document.getElementById('cart-icon-bubble');
        if (!json || !bubble || !json['cart-icon-bubble']) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = json['cart-icon-bubble'];
        var inner = tmp.querySelector('.shopify-section');
        bubble.innerHTML = inner ? inner.innerHTML : tmp.innerHTML;
      })
      .catch(function () {});
    // Rebuy Smart Cart (enabled on this store) — refresh; open only when asked.
    try {
      var R = window.Rebuy;
      if (R && R.Cart && typeof R.Cart.fetchCart === 'function') R.Cart.fetchCart();
      if (openDrawer && R && R.SmartCart && typeof R.SmartCart.show === 'function') R.SmartCart.show();
    } catch (e) {}
    document.dispatchEvent(new CustomEvent('ph26:cart-updated'));
  }

  function addToCart(id) {
    return fetch(root_url + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error((res.json && (res.json.description || res.json.message)) || 'Could not add to cart');
        return res.json;
      });
  }

  // After any successful add: phones with the haul bar in view confirm in the bar; everything else opens the drawer.
  // Adds from the ad spotlight (product card, "Complete your haul" rail) stay on the page and advance the haul instead.
  function afterAdded(origin) {
    if (origin && origin.closest && origin.closest('[data-ph26-focus]')) { haulAdded(origin); return; }
    var bar = document.querySelector('[data-ph26-progress]');
    var inBar = bar && bar.getAttribute('data-after-add') !== 'drawer' && progressBarShown();
    if (inBar) { justAddedUntil = Date.now() + 2500; justAddedFlash = true; }
    refreshCartUi(!inBar);
  }

  /* ---------- Quick Add (only rendered for allow-listed single-variant products, and the rider switcher) ---------- */
  function onAddClick(e) {
    var btn = e.target.closest('.ph26 [data-ph26-add]');
    if (!btn || btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
    if (cardIsCustom(btn)) { window.location.href = btn.getAttribute('data-url') || btn.closest('[data-ph26-card]').querySelector('a[href]').href; return; }
    var id = parseInt(btn.getAttribute('data-ph26-add'), 10);
    if (!id) return;
    var label = btn.textContent;
    btn.setAttribute('aria-busy', 'true');
    addToCart(id)
      .then(function () {
        btn.textContent = 'Added ✓';
        afterAdded(btn);
        setTimeout(function () { btn.textContent = label; }, 2000);
      })
      .catch(function (err) {
        btn.textContent = err && err.message ? err.message : 'Please try again';
        setTimeout(function () { btn.textContent = label; }, 3000);
      })
      .finally(function () { btn.removeAttribute('aria-busy'); });
  }

  /* ---------- Rider switcher ---------- */
  function selectRider(tab) {
    var section = tab.closest('[data-ph26-rider]');
    if (!section) return;
    var vid = tab.getAttribute('data-variant');
    section.querySelectorAll('.ph26-rider__tab').forEach(function (t) {
      var on = t === tab;
      t.setAttribute('aria-checked', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
    });
    section.querySelectorAll('.ph26-rider__slide').forEach(function (s) {
      s.hidden = s.getAttribute('data-variant') !== vid;
    });
    var name = section.querySelector('[data-ph26-rider-name]');
    if (name) name.textContent = tab.getAttribute('data-title');
    var add = section.querySelector('[data-ph26-rider-add]');
    if (add) {
      add.setAttribute('data-ph26-add', vid);
      add.disabled = tab.hasAttribute('data-soldout');
      add.textContent = (add.getAttribute('data-template') || 'Add [style] — [price]')
        .replace('[style]', tab.getAttribute('data-title'))
        .replace('[price]', tab.getAttribute('data-price'));
    }
  }

  function onRiderClick(e) {
    var tab = e.target.closest('.ph26 .ph26-rider__tab');
    if (tab) selectRider(tab);
  }

  function onRiderKey(e) {
    var tab = e.target.closest('.ph26 .ph26-rider__tab');
    if (!tab) return;
    var keys = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };
    if (!(e.key in keys) && e.key !== 'Home' && e.key !== 'End') return;
    var tabs = Array.prototype.slice.call(tab.parentElement.querySelectorAll('.ph26-rider__tab'));
    var i = tabs.indexOf(tab);
    var next = e.key === 'Home' ? 0 : e.key === 'End' ? tabs.length - 1 : (i + keys[e.key] + tabs.length) % tabs.length;
    e.preventDefault();
    tabs[next].focus();
    selectRider(tabs[next]);
    tabs[next].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: reduceMotion.matches ? 'auto' : 'smooth' });
  }

  /* ---------- Mobile multi-buy progress bar (only rendered when both percentages are set) ---------- */
  var DISMISS_KEY = 'ph26-progress-dismissed';

  function progressDismissed() {
    try { return window.sessionStorage.getItem(DISMISS_KEY) === '1'; } catch (e) { return false; }
  }

  // "Added ✓" confirmation stays for 2.5 s: several cart refreshes (ours + Rebuy's cart.change) arrive in a row.
  var justAddedUntil = 0;
  var justAddedFlash = false;
  var eligibleCache;

  function eligibleIds() {
    if (eligibleCache !== undefined) return eligibleCache;
    eligibleCache = null;
    var el = document.querySelector('script[data-ph26-eligible]');
    if (!el) return eligibleCache;
    try {
      var arr = JSON.parse(el.textContent);
      if (arr.length > 1) { // [..., 0]: a lone 0 means "no eligibility filter"
        eligibleCache = {};
        arr.forEach(function (id) { if (id) eligibleCache[id] = true; });
      }
    } catch (e) {}
    return eligibleCache;
  }

  function updateProgress(cart) {
    updateHaul(cart);
    var bar = document.querySelector('[data-ph26-progress]');
    if (!bar) return;
    var p2 = bar.getAttribute('data-p2');
    var p3 = bar.getAttribute('data-p3');
    var code = bar.getAttribute('data-code') || '';
    var offerEnd = Date.parse(bar.getAttribute('data-offer-end') || '');
    if (!isNaN(offerEnd) && Date.now() >= offerEnd) { p2 = ''; p3 = ''; }   // offer over: free-shipping mode only
    var offer = !!p3;   // 3+ tier alone is enough; the 2-item tier is optional
    var ship = parseInt(bar.getAttribute('data-ship-cents') || '0', 10) || 0;
    var items = (cart && cart.items) || [];
    var total = (cart && cart.total_price) || 0;
    var ids = eligibleIds();
    var count = 0;
    items.forEach(function (it) { if (!ids || ids[it.product_id]) count += it.quantity; });
    var gap = ship ? Math.max(0, ship - total) : 0;
    var text, sub = '', fill;

    if (offer) {
      if (p2) {
        if (count <= 0) text = 'Add 2 items, save ' + p2 + '%';
        else if (count === 1) text = 'Add 1 more to save ' + p2 + '%';
        else if (count === 2) text = 'Add 1 more to save ' + p3 + '%';
        else text = 'You’re saving ' + p3 + '%';
      } else if (code) {
        // Code offer: the saving only applies once the shopper enters the code at checkout.
        if (count <= 0) text = 'Add 3 items, save ' + p3 + '% with ' + code;
        else if (count < 3) text = 'Add ' + (3 - count) + ' more · save ' + p3 + '% with ' + code;
        else text = 'Use code ' + code + ' at checkout for ' + p3 + '% off';
      } else {
        if (count <= 0) text = 'Add 3 items, save ' + p3 + '%';
        else if (count < 3) text = 'Add ' + (3 - count) + ' more to save ' + p3 + '%';
        else text = 'You’re saving ' + p3 + '%';
      }
      if (ship && total > 0) sub = gap > 0 ? money(gap) + ' to free shipping' : 'Free shipping unlocked';
      fill = Math.min(1, count / 3);
    } else {
      if (total <= 0) text = 'Free shipping on orders ' + money(ship) + '+';
      else if (gap > 0) text = 'You’re ' + money(gap) + ' away from free shipping';
      else text = 'You’ve unlocked free shipping';
      fill = ship ? Math.min(1, total / ship) : 0;
    }
    if (Date.now() < justAddedUntil) {
      // Short confirmation so it fits two lines next to “View Cart (n)” at 390px.
      if (!offer && ship) text = 'Added ✓ · ' + (gap > 0 ? money(gap) + ' to free shipping' : 'Free shipping unlocked');
      else text = 'Added ✓ · ' + text;
      if (justAddedFlash) { justAddedFlash = false; flashBar(bar); }
      clearTimeout(bar.ph26AddedTimer);
      bar.ph26AddedTimer = setTimeout(fetchCartCount, justAddedUntil - Date.now() + 50);
    }

    bar.querySelector('[data-ph26-progress-text]').textContent = text;
    var subEl = bar.querySelector('[data-ph26-progress-sub]');
    if (subEl) { subEl.textContent = sub; subEl.hidden = !sub; }
    bar.querySelector('[data-ph26-progress-fill]').style.width = Math.round(fill * 100) + '%';

    var cartBtn = bar.querySelector('[data-ph26-cart-open]');
    if (cartBtn) {
      var n = (cart && cart.item_count) || 0;
      cartBtn.hidden = n <= 0;
      var cnt = cartBtn.querySelector('[data-ph26-cart-count]');
      if (cnt) cnt.textContent = n > 0 ? '\u00a0(' + n + ')' : '';
    }

    // Add-on rail subheading: the visitor's real free-shipping gap.
    document.querySelectorAll('.ph26 [data-ph26-gap-text]').forEach(function (el) {
      var t = el.getAttribute('data-default') || el.textContent;
      if (ship && total > 0) {
        t = gap > 0 ? 'You’re ' + money(gap) + ' away from free shipping — any of these gets you closer.' : 'Free shipping unlocked. Room for one more treat?';
      }
      el.textContent = t;
    });
  }

  // .is-flash marks the "just added" state for 2.5 s (the bar text turns candy yellow via CSS, also under reduced motion;
  // the amber fade animation itself is disabled for reduced motion in CSS).
  function flashBar(bar) {
    clearTimeout(bar.ph26FlashTimer);
    bar.classList.remove('is-flash');
    void bar.offsetWidth;
    bar.classList.add('is-flash');
    bar.ph26FlashTimer = setTimeout(function () { bar.classList.remove('is-flash'); }, 2500);
  }

  function fetchCartCount() {
    if (!document.querySelector('[data-ph26-progress], [data-ph26-haul]')) return;
    fetch(root_url + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { updateProgress(c); })
      .catch(function () {});
  }

  function onCartOpenClick(e) {
    if (!e.target.closest('[data-ph26-cart-open]')) return;
    openCartDrawer();
  }

  var progressObserver = null;

  function initProgress() {
    var bar = document.querySelector('[data-ph26-progress]');
    var hero = document.querySelector('[data-ph26-hero]');
    if (!bar) return;
    if (progressDismissed()) { bar.hidden = true; return; }
    fetchCartCount();
    if (progressObserver) progressObserver.disconnect();
    if (!hero || !('IntersectionObserver' in window)) { bar.hidden = false; return; }
    progressObserver = new IntersectionObserver(function (entries) {
      if (progressDismissed()) { bar.hidden = true; return; }
      bar.hidden = entries[0].isIntersecting;
    });
    progressObserver.observe(hero);
  }

  function onProgressClose(e) {
    var btn = e.target.closest('[data-ph26-progress-close]');
    if (!btn) return;
    try { window.sessionStorage.setItem(DISMISS_KEY, '1'); } catch (err) {}
    var bar = btn.closest('[data-ph26-progress]');
    if (bar) bar.hidden = true;
    if (progressObserver) progressObserver.disconnect();
  }

  document.addEventListener('click', onAddClick);
  document.addEventListener('click', onRiderClick);
  document.addEventListener('keydown', onRiderKey);
  document.addEventListener('click', onProgressClose);
  document.addEventListener('click', onCartOpenClick);
  document.addEventListener('ph26:cart-updated', fetchCartCount);
  document.addEventListener('rebuy:cart.change', fetchCartCount);

  /* ---------- In-page variant picker (bottom sheet) ----------
     Rendered only for products on a section's allow-list (verified: no personalization / Globo option fields).
     Chooses among the product's native Shopify variants; "Size guide & full details" always links to the product page. */
  var sheet = null;
  var sheetTrigger = null;
  var pickerRequest = 0;

  function esc(t) {
    return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function sizedImg(src, w) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function closePicker() {
    pickerRequest++;
    if (!sheet) return;
    sheet.remove();
    sheet = null;
    root.classList.remove('ph26-sheet-open');
    document.removeEventListener('keydown', onSheetKey, true);
    if (sheetTrigger) { sheetTrigger.focus(); sheetTrigger = null; }
  }

  function onSheetKey(e) {
    if (!sheet) return;
    if (e.key === 'Escape') { e.preventDefault(); closePicker(); return; }
    if (e.key !== 'Tab') return;
    var f = sheet.querySelectorAll('button:not([disabled]), a[href]');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function renderPicker(product, url, card) {
    var title = String(product.title || '');
    var start = product.variants.filter(function (v) { return v.available; })[0] || product.variants[0];
    var chosen = start.options.slice();

    var opts = product.options.map(function (o, i) {
      var name = typeof o === 'string' ? o : o.name;
      var values = typeof o === 'string' ? [] : o.values;
      if (!values.length) {
        product.variants.forEach(function (v) { if (values.indexOf(v.options[i]) < 0) values.push(v.options[i]); });
      }
      return '<fieldset class="ph26-sheet__opt"><legend>' + esc(name) + ': <span data-ph26-opt-val="' + i + '">' + esc(chosen[i]) + '</span></legend>' +
        '<div class="ph26-sheet__vals">' + values.map(function (val) {
          return '<button type="button" class="ph26-sheet__val" data-i="' + i + '" data-v="' + esc(val) + '" aria-pressed="' + (val === chosen[i]) + '">' + esc(val) + '</button>';
        }).join('') + '</div></fieldset>';
    }).join('');

    if (product.variants.length === 1 && product.variants[0].title === 'Default Title') opts = '';
    var sizeIdx = -1;
    product.options.forEach(function (o, i) { if (sizeIdx < 0 && /size/i.test(typeof o === 'string' ? o : o.name)) sizeIdx = i; });
    sheet = document.createElement('div');
    var mySheet = sheet;
    var originTrigger = sheetTrigger;
    sheet.className = 'ph26 ph26-sheet';
    sheet.innerHTML =
      '<div class="ph26-sheet__backdrop" data-ph26-sheet-close></div>' +
      '<div class="ph26-sheet__panel" role="dialog" aria-modal="true" aria-labelledby="ph26-sheet-title">' +
        '<button type="button" class="ph26-sheet__close" data-ph26-sheet-close aria-label="Close">' +
          '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button>' +
        '<div class="ph26-sheet__head"><img class="ph26-sheet__img" alt="" width="96" height="96">' +
          '<div><p class="ph26-sheet__title" id="ph26-sheet-title">' + esc(title) + '</p><p class="ph26-sheet__price" data-ph26-sheet-price></p></div></div>' +
        opts +
        (sizeIdx > -1 && card && card.hasAttribute('data-ks') ? '<details class="ph26-sheet__size" open data-ph26-ks><summary>Size chart</summary><div class="ph26-ks" data-ph26-ks-body><p class="ph26-ks__note">Loading size chart…</p></div></details>' : '') +
        '<button type="button" class="ph26-btn ph26-btn--primary ph26-btn--wide ph26-sheet__add" data-ph26-sheet-add></button>' +
        '<a class="ph26-sheet__more" href="' + esc(url) + '">Full product details</a>' +
      '</div>';
    document.body.appendChild(sheet);
    root.classList.add('ph26-sheet-open');
    document.addEventListener('keydown', onSheetKey, true);

    function current() {
      return product.variants.filter(function (v) {
        return v.options.every(function (val, i) { return val === chosen[i]; });
      })[0];
    }

    function sync() {
      if (sheet !== mySheet) return;
      var v = current();
      var img = (v && v.featured_image && v.featured_image.src) || product.featured_image;
      sheet.querySelector('.ph26-sheet__img').src = sizedImg(img, 240);
      sheet.querySelector('[data-ph26-sheet-price]').textContent = money(v ? v.price : product.price);
      var add = sheet.querySelector('[data-ph26-sheet-add]');
      add.disabled = !(v && v.available);
      add.textContent = !v ? 'Unavailable' : v.available ? 'Add to Cart — ' + money(v.price) : 'Sold Out';
      add.setAttribute('data-variant', v ? v.id : '');
      // Mark values that cannot make an available variant with the other current choices.
      sheet.querySelectorAll('.ph26-sheet__val').forEach(function (b) {
        var i = +b.getAttribute('data-i');
        var test = chosen.slice(); test[i] = b.getAttribute('data-v');
        var ok = product.variants.some(function (x) {
          return x.available && x.options.every(function (val, k) { return val === test[k]; });
        });
        b.classList.toggle('is-out', !ok);
        b.setAttribute('aria-pressed', String(b.getAttribute('data-v') === chosen[i]));
      });
      sheet.querySelectorAll('[data-ph26-opt-val]').forEach(function (el) { el.textContent = chosen[+el.getAttribute('data-ph26-opt-val')]; });
      if (sizeIdx > -1) markKiwiSize(sheet, chosen[sizeIdx]);
    }

    sheet.addEventListener('click', function (e) {
      if (e.target.closest('[data-ph26-sheet-close]')) { closePicker(); return; }
      var val = e.target.closest('.ph26-sheet__val');
      if (val) { chosen[+val.getAttribute('data-i')] = val.getAttribute('data-v'); sync(); return; }
      var unitBtn = e.target.closest('[data-ph26-ks-unit]');
      if (unitBtn) { kiwiUnit = unitBtn.getAttribute('data-ph26-ks-unit'); drawKiwi(sheet, product.id); if (sizeIdx > -1) markKiwiSize(sheet, chosen[sizeIdx]); return; }
      var add = e.target.closest('[data-ph26-sheet-add]');
      if (add && !add.disabled && add.getAttribute('aria-busy') !== 'true') {
        add.setAttribute('aria-busy', 'true');
        addToCart(parseInt(add.getAttribute('data-variant'), 10))
          .then(function () { if (sheet === mySheet) closePicker(); afterAdded(originTrigger); })
          .catch(function (err) {
            if (sheet !== mySheet) return;
            add.textContent = err && err.message ? err.message : 'Please try again';
            setTimeout(sync, 3000);
          })
          .finally(function () { add.removeAttribute('aria-busy'); });
      }
    });

    sync();
    if (sizeIdx > -1 && card && card.hasAttribute('data-ks')) {
      loadKiwi(product, card).then(function () {
        if (sheet !== mySheet) return;
        drawKiwi(sheet, product.id);
        markKiwiSize(sheet, chosen[sizeIdx]);
      });
    }
    var firstBtn = sheet.querySelector('.ph26-sheet__val[aria-pressed="true"]') || sheet.querySelector('button');
    if (firstBtn) firstBtn.focus();
  }

  /* ---------- Size chart from Kiwi Sizing (same public endpoint the product page uses) ----------
     Renders the product's Kiwi tables, notes and measuring images inside the picker, with an in/cm switch.
     No chart or any error: the size-chart block simply stays hidden. */
  var kiwiCache = {};
  var kiwiUnit = (window.Shopify && window.Shopify.country && window.Shopify.country !== 'US') ? 'metric' : 'imperial';
  var KIWI_CONV = { in: ['cm', 2.54], cm: ['in', 1 / 2.54], lb: ['kg', 0.45359237], kg: ['lb', 1 / 0.45359237] };
  var KIWI_METRIC = { cm: 1, kg: 1 };

  function loadKiwi(product, card) {
    var id = product.id || card.getAttribute('data-pid');
    if (kiwiCache[id]) return kiwiCache[id];
    var shop = (window.Shopify && window.Shopify.shop) || '';
    var q = 'shop=' + encodeURIComponent(shop) +
      '&product=' + id +
      '&title=' + encodeURIComponent(card.getAttribute('data-ks-title') || product.title || '') +
      '&tags=' + encodeURIComponent(card.getAttribute('data-ks') || '') +
      '&metafields=%5B%5D' +
      '&vendor=' + encodeURIComponent(card.getAttribute('data-ks-vendor') || product.vendor || '') +
      '&collections=' + encodeURIComponent(card.getAttribute('data-ks-cols') || '');
    kiwiCache[id] = shop ? fetch('https://app.kiwisizing.com/api/getSizingChart?' + q)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { kiwiCache[id + ':data'] = j && j.sizings && j.sizings.length ? j.sizings : null; })
      .catch(function () { kiwiCache[id + ':data'] = null; }) : Promise.resolve();
    return kiwiCache[id];
  }

  function kiwiValue(value, unit) {
    var v = esc(value);
    if (!KIWI_CONV[unit]) return v;
    var wantMetric = kiwiUnit === 'metric';
    if (!!KIWI_METRIC[unit] === wantMetric) return v + ' <small>' + unit + '</small>';
    var c = KIWI_CONV[unit];
    return esc(String(value).replace(/\d+(?:\.\d+)?/g, function (n) {
      var x = Math.round(parseFloat(n) * c[1] * 10) / 10;
      return String(x);
    })) + ' <small>' + c[0] + '</small>';
  }

  // Kiwi notes are merchant HTML: keep text and a few inline tags only.
  function kiwiText(html) {
    var doc = new DOMParser().parseFromString('<div>' + html + '</div>', 'text/html');
    var ok = { P: 1, STRONG: 1, B: 1, EM: 1, I: 1, BR: 1, UL: 1, OL: 1, LI: 1, SPAN: 1 };
    (function clean(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (n) {
        if (n.nodeType === 1) {
          if (!ok[n.tagName]) { n.replaceWith(document.createTextNode(n.textContent)); return; }
          Array.prototype.slice.call(n.attributes).forEach(function (a) { n.removeAttribute(a.name); });
          clean(n);
        } else if (n.nodeType !== 3) { n.remove(); }
      });
    })(doc.body.firstChild);
    return doc.body.firstChild.innerHTML;
  }

  function drawKiwi(sheetEl, id) {
    var box = sheetEl.querySelector('[data-ph26-ks]');
    var body = sheetEl.querySelector('[data-ph26-ks-body]');
    var sizings = kiwiCache[id + ':data'];
    if (!box || !body) return;
    if (!sizings) { box.hidden = true; return; }
    var convertible = false;
    var html = '';
    sizings.forEach(function (sz) {
      ((sz.layout && sz.layout.data) || []).forEach(function (l) {
        if (l.type === 0 && l.value) html += '<div class="ph26-ks__note">' + kiwiText(l.value) + '</div>';
        if (l.type === 6 && l.data && /^https:\/\/cdn\.kiwisizing\.com\//.test(l.data.url || '')) {
          html += '<img class="ph26-ks__img" src="' + esc(l.data.url) + '" alt="How to measure" loading="lazy">';
        }
        var t = l.type === 1 && sz.tables && sz.tables[l.value];
        if (!t || t.hide || !t.data || !t.data.length) return;
        var dir = t.direction === 'row' ? 'row' : 'col';
        html += '<div class="ph26-ks__scroll"><table class="ph26-ks__table" data-dir="' + dir + '">' + t.data.map(function (row, r) {
          return '<tr>' + row.map(function (c, k) {
            if (KIWI_CONV[c.unitType]) convertible = true;
            var head = c.type === 'header' || r === 0;
            var key = (dir === 'col' ? k === 0 : r === 0) ? ' data-size="' + esc(String(c.value).trim().toLowerCase()) + '"' : '';
            return head ? '<th scope="' + (r === 0 ? 'col' : 'row') + '"' + key + '>' + esc(c.value) + '</th>' : '<td>' + kiwiValue(c.value, c.unitType) + '</td>';
          }).join('') + '</tr>';
        }).join('') + '</table></div>';
      });
    });
    if (!html) { box.hidden = true; return; }
    var toggle = convertible
      ? '<div class="ph26-ks__units" role="group" aria-label="Units">' +
          '<button type="button" data-ph26-ks-unit="imperial" aria-pressed="' + (kiwiUnit === 'imperial') + '">in / lb</button>' +
          '<button type="button" data-ph26-ks-unit="metric" aria-pressed="' + (kiwiUnit === 'metric') + '">cm / kg</button>' +
        '</div>'
      : '';
    body.innerHTML = toggle + html;
    box.hidden = false;
  }

  // Highlight the chosen size in the chart (row for column tables, column for row tables).
  function markKiwiSize(sheetEl, size) {
    var key = String(size || '').trim().toLowerCase();
    sheetEl.querySelectorAll('.ph26-ks__table').forEach(function (t) {
      t.querySelectorAll('.is-sel').forEach(function (c) { c.classList.remove('is-sel'); });
      var hit = t.querySelector('[data-size="' + (window.CSS && CSS.escape ? CSS.escape(key) : key) + '"]');
      if (!hit || !key) return;
      if (t.getAttribute('data-dir') === 'row') {
        var idx = hit.cellIndex;
        t.querySelectorAll('tr').forEach(function (tr) { if (tr.cells[idx]) tr.cells[idx].classList.add('is-sel'); });
      } else {
        Array.prototype.forEach.call(hit.parentElement.cells, function (c) { c.classList.add('is-sel'); });
      }
    });
  }

  /* ---------- Personalization check (Globo Product Options) ----------
     A product mapped to a Globo option set has custom fields (name, photo, ...) that only the product page can collect.
     Mapped = personalized, unless every mapped set is explicitly disabled (status 1). Without Globo config the
     product page has no custom fields either, so in-page buying is safe. */
  function isPersonalized(pid) {
    var G = window.GPOConfigs;
    var map = G && G.productOptionSetMap;
    if (!map || !pid || !map[pid]) return false;
    return String(map[pid]).split(',').some(function (sid) {
      var o = G.options && G.options[sid.trim()];
      return !(o && String(o.status) === '1');
    });
  }

  function cardIsCustom(el) {
    var card = el && el.closest('[data-ph26-card]');
    return !!(card && isPersonalized(card.getAttribute('data-pid')));
  }

  // Personalized cards: "Personalize" link to the product page instead of Quick Add / picker.
  function upgradeCards(scope) {
    (scope || document).querySelectorAll('.ph26 [data-ph26-card]:not([data-ph26-checked])').forEach(function (card) {
      card.setAttribute('data-ph26-checked', '');
      if (!isPersonalized(card.getAttribute('data-pid'))) return;
      card.setAttribute('data-ph26-custom', '');
      card.querySelectorAll('a[data-ph26-pick]').forEach(function (a) {
        a.removeAttribute('data-ph26-pick');
        a.removeAttribute('aria-haspopup');
      });
      var btn = card.querySelector('.ph26-card__btn');
      var link = card.querySelector('.ph26-card__title a');
      if (!btn || btn.tagName === 'A' || !link) return;
      var a = document.createElement('a');
      a.className = btn.className + ' ph26-card__btn--custom';
      a.href = link.getAttribute('href');
      a.textContent = 'Personalize';
      a.setAttribute('aria-label', 'Personalize: ' + link.textContent.trim());
      btn.replaceWith(a);
    });
  }

  /* ---------- Load more from a collection (Section Rendering API, sections/ph26-feed.liquid) ----------
     <ul data-ph26-feed="/collections/x" data-ph26-feed-step="N" [data-ph26-feed-sort] [data-ph26-feed-exclude="self|#id"]
         [data-ph26-feed-auto] [data-ph26-feed-item-class]> + a [data-ph26-feed-more] button nearby.
     Products already shown in the excluded area are skipped; pages are fetched as needed. */
  function Feed(list) {
    this.list = list;
    this.step = parseInt(list.getAttribute('data-ph26-feed-step'), 10) || 16;
    this.page = 0;
    this.pages = null;
    this.buffer = [];
    this.busy = null;
    this.total = parseInt(list.getAttribute('data-ph26-feed-total'), 10) || 0;
    var wrap = list.closest('.ph26-all, .ph26-wanted, .ph26-addons') || list.parentElement;
    this.moreBtn = wrap.querySelector('[data-ph26-feed-more]');
    this.status = wrap.querySelector('[data-ph26-feed-status]');
    // Add-on / gift / favourites / haul lists also skip products the page already shows (Shop All stays complete).
    this.dedupe = !!list.closest('.ph26-addons, .ph26-wanted, .ph26-gifts');
    var ex = list.getAttribute('data-ph26-feed-exclude');
    var exScope = ex === 'self' ? list : ex ? document.querySelector(ex) : null;
    this.seen = {};
    var self = this;
    (exScope ? exScope.querySelectorAll('[data-ph26-card]') : []).forEach(function (c) { self.seen[c.getAttribute('data-handle')] = true; });
  }

  Feed.prototype.url = function (page) {
    var base = this.list.getAttribute('data-ph26-feed');
    var sort = this.list.getAttribute('data-ph26-feed-sort');
    return base + (base.indexOf('?') > -1 ? '&' : '?') + 'section_id=ph26-feed&page=' + page + (sort ? '&sort_by=' + encodeURIComponent(sort) : '');
  };

  Feed.prototype.done = function () { return this.pages !== null && this.page >= this.pages && !this.buffer.length; };

  Feed.prototype.fetchPage = function () {
    var self = this;
    var next = this.page + 1;
    return fetch(this.url(next), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var pg = tmp.querySelector('[data-ph26-feed-page]');
        self.page = next;
        self.pages = pg ? parseInt(pg.getAttribute('data-pages'), 10) || next : next;
        if (pg && !self.total) self.total = parseInt(pg.getAttribute('data-total'), 10) || 0;
        tmp.querySelectorAll('[data-ph26-feed-item]').forEach(function (it) {
          var h = it.getAttribute('data-handle');
          var card = it.querySelector('[data-ph26-card]');
          if (!card || self.seen[h] || (self.dedupe && isSeen(h))) return;
          self.seen[h] = true;
          self.buffer.push(card);
        });
      });
  };

  Feed.prototype.fill = function () {
    var self = this;
    if (this.buffer.length >= this.step || (this.pages !== null && this.page >= this.pages)) return Promise.resolve();
    return this.fetchPage().then(function () { return self.fill(); });
  };

  Feed.prototype.more = function () {
    var self = this;
    if (this.busy) return this.busy;
    if (this.done()) return Promise.resolve(0);
    if (this.moreBtn) this.moreBtn.setAttribute('aria-busy', 'true');
    this.busy = this.fill()
      .then(function () {
        var cls = self.list.getAttribute('data-ph26-feed-item-class');
        var added = self.buffer.splice(0, self.step);
        added.forEach(function (card) {
          var li = document.createElement('li');
          if (cls) li.className = cls;
          li.appendChild(card);
          self.list.appendChild(li);
        });
        upgradeCards(self.list);
        initReveal(self.list);
        self.update(added.length);
        return added.length;
      })
      .catch(function () {
        if (self.status) self.status.textContent = 'Could not load more products. Please try again.';
        return 0;
      })
      .finally(function () {
        self.busy = null;
        if (self.moreBtn) self.moreBtn.removeAttribute('aria-busy');
      });
    return this.busy;
  };

  Feed.prototype.update = function (added) {
    var shown = this.list.querySelectorAll('[data-ph26-card]').length;
    var end = this.done();
    if (this.moreBtn) this.moreBtn.hidden = end;
    if (!this.status) return;
    if (this.total && this.list.closest('.ph26-all')) this.status.textContent = 'Showing ' + shown + ' of ' + this.total;
    else if (added) this.status.textContent = added + ' more products added.';
    if (end && this.list.closest('.ph26-wanted') && this.moreBtn) this.moreBtn.hidden = true;
  };

  function feedFor(list) {
    if (!list.ph26Feed) list.ph26Feed = new Feed(list);
    return list.ph26Feed;
  }

  function onFeedMore(e) {
    var btn = e.target.closest('.ph26 [data-ph26-feed-more]');
    if (!btn || btn.getAttribute('aria-busy') === 'true') return;
    var scope = btn.closest('.ph26-all, .ph26-wanted, .ph26-addons');
    var list = scope && scope.querySelector('[data-ph26-feed]');
    if (!list) return;
    var before = list.querySelectorAll('[data-ph26-card]').length;
    feedFor(list).more().then(function (n) {
      var first = n ? list.querySelectorAll('[data-ph26-card]')[before] : null;
      var link = first && first.querySelector('.ph26-card__title a');
      if (link) link.focus({ preventScroll: true });
    });
  }

  // "Shop All Halloween": opens the in-page grid and loads the first 16 products.
  function onAllOpen(e) {
    var btn = e.target.closest('.ph26 [data-ph26-all-open]');
    if (!btn) return;
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (!panel) return;
    var open = btn.getAttribute('aria-expanded') !== 'true';
    btn.setAttribute('aria-expanded', String(open));
    panel.hidden = !open;
    if (!btn.getAttribute('data-label')) btn.setAttribute('data-label', btn.innerHTML);
    btn.innerHTML = open ? 'Hide All Halloween' : btn.getAttribute('data-label');
    if (!open) return;
    var list = panel.querySelector('[data-ph26-feed]');
    var feed = list && feedFor(list);
    if (feed && !feed.page) {
      panel.classList.add('is-loading');
      feed.more().then(function () { panel.classList.remove('is-loading'); });
    }
    panel.scrollIntoView({ block: 'start', behavior: reduceMotion.matches ? 'auto' : 'smooth' });
  }

  /* ---------- Rails: swipe + arrows (add-ons rail, Pup & Me look items) ----------
     [data-ph26-rail] wraps a horizontal scroller (ul). Arrows page by the visible width, or by one item for
     single-item rails ([data-ph26-rail-single], with an "n / total" counter). Rails with a feed load more at the end. */
  function railParts(rail) {
    return { list: rail.querySelector('ul'), prev: rail.querySelector('[data-ph26-rail-prev]'), next: rail.querySelector('[data-ph26-rail-next]'), count: rail.querySelector('[data-ph26-rail-count]') };
  }

  function railUpdate(rail) {
    var p = railParts(rail);
    if (!p.list) return;
    var max = p.list.scrollWidth - p.list.clientWidth;
    var x = Math.abs(p.list.scrollLeft);
    var feed = p.list.hasAttribute('data-ph26-feed') ? feedFor(p.list) : null;
    if (p.prev) p.prev.disabled = x <= 2;
    if (p.next) p.next.disabled = x >= max - 2 && !(feed && !feed.done());
    rail.classList.toggle('is-scrollable', max > 2 || !!(feed && !feed.done()));
    if (p.count) {
      var items = p.list.children.length;
      var w = p.list.clientWidth || 1;
      p.count.textContent = Math.min(items, Math.round(x / w) + 1) + ' / ' + items;
    }
    // Keep-scrolling rails: fetch the next products before the shopper reaches the end.
    if (feed && p.list.hasAttribute('data-ph26-feed-auto') && x >= max - p.list.clientWidth * 1.5 && !feed.done() && rail.ph26Seen) {
      feed.more().then(function (n) { if (n) railUpdate(rail); });
    }
  }

  function railStep(rail, dir) {
    var p = railParts(rail);
    var single = rail.hasAttribute('data-ph26-rail-single');
    var first = p.list.children[0];
    var gap = parseFloat(getComputedStyle(p.list).columnGap) || 0;
    var item = first ? first.getBoundingClientRect().width + gap : p.list.clientWidth;
    var by = single ? p.list.clientWidth : Math.max(item, Math.floor(p.list.clientWidth / item) * item);
    var max = p.list.scrollWidth - p.list.clientWidth;
    var go = function () { p.list.scrollBy({ left: dir * by, behavior: reduceMotion.matches ? 'auto' : 'smooth' }); };
    var feed = p.list.hasAttribute('data-ph26-feed') ? feedFor(p.list) : null;
    if (dir > 0 && feed && p.list.scrollLeft >= max - by && !feed.done()) feed.more().then(function () { go(); railUpdate(rail); });
    else go();
  }

  function onRailClick(e) {
    var b = e.target.closest('.ph26 [data-ph26-rail-prev], .ph26 [data-ph26-rail-next]');
    if (!b) return;
    var rail = b.closest('[data-ph26-rail]');
    if (rail) railStep(rail, b.hasAttribute('data-ph26-rail-next') ? 1 : -1);
  }

  function initRails(scope) {
    (scope || document).querySelectorAll('.ph26 [data-ph26-rail]').forEach(function (rail) {
      if (rail.ph26Rail) return;
      rail.ph26Rail = true;
      var list = railParts(rail).list;
      if (!list) return;
      var t = 0;
      list.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(function () { railUpdate(rail); }, 60); }, { passive: true });
      list.addEventListener('scrollend', function () { clearTimeout(t); railUpdate(rail); });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) { if (en[0].isIntersecting) { rail.ph26Seen = true; railUpdate(rail); } }, { rootMargin: '200px 0px' }).observe(rail);
      } else { rail.ph26Seen = true; }
      railUpdate(rail);
    });
  }

  // Warm the size chart while the shopper is about to tap "Choose Size".
  function prefetchKiwi(e) {
    var btn = e.target.closest && e.target.closest('.ph26 [data-ph26-pick]');
    var card = btn && btn.closest('[data-ph26-card][data-ks]');
    if (card && !card.hasAttribute('data-ph26-custom')) loadKiwi({}, card);
  }
  document.addEventListener('pointerover', prefetchKiwi, { passive: true });
  document.addEventListener('touchstart', prefetchKiwi, { passive: true });
  document.addEventListener('focusin', prefetchKiwi);

  document.addEventListener('click', onFeedMore);
  document.addEventListener('click', onAllOpen);
  document.addEventListener('click', onRailClick);
  window.addEventListener('resize', function () { document.querySelectorAll('.ph26 [data-ph26-rail]').forEach(railUpdate); }, { passive: true });

  function onPickClick(e) {
    var btn = e.target.closest('.ph26 [data-ph26-pick]');
    if (!btn || btn.getAttribute('aria-busy') === 'true') return;
    var handle = btn.getAttribute('data-ph26-pick');
    var url = btn.getAttribute('data-url') || (root_url + 'products/' + handle);
    if (cardIsCustom(btn)) { // personalized product: go to the product page (links do this on their own)
      if (btn.tagName !== 'A') window.location.href = url;
      return;
    }
    e.preventDefault();
    var card = btn.closest('[data-ph26-card]');
    closePicker();
    var request = pickerRequest;
    btn.setAttribute('aria-busy', 'true');
    fetch(root_url + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
      .then(function (product) { if (request !== pickerRequest) return; sheetTrigger = btn; renderPicker(product, url, card); })
      .catch(function () { if (request === pickerRequest) window.location.href = url; }) // any problem: fall back to the product page
      .finally(function () { btn.removeAttribute('aria-busy'); });
  }

  document.addEventListener('click', onPickClick);

  /* ---------- Ad match: retarget the hero's primary button ---------- */
  function initFocus() {
    var btn = document.querySelector('.ph26 [data-ph26-focus-map]');
    if (!btn || btn.getAttribute('data-ph26-focus-done')) return;
    var params;
    try { params = new URLSearchParams(window.location.search); } catch (e) { return; }
    var key = (params.get('focus') || '').toLowerCase();
    var utm = (params.get('utm_content') || '').toLowerCase();
    btn.getAttribute('data-ph26-focus-map').split(/\r?\n/).some(function (line) {
      var parts = line.split('|').map(function (x) { return x.trim(); });
      if (parts.length < 3 || !parts[0]) return false;
      var k = parts[0].toLowerCase();
      if (key === k || (!key && utm && utm.indexOf(k) > -1)) {
        btn.textContent = parts[1];
        btn.setAttribute('href', parts[2]);
        return true;
      }
      return false;
    });
    btn.setAttribute('data-ph26-focus-done', '1');
  }

  /* ---------- Page de-duplication: each product is shown in full once ----------
     Walks the page top-down after the spotlight (if any) is settled:
     - feature modules (Most-Wanted, rider, wig, Pup & Me) always stay and claim their products first;
       in spotlight mode a rider/wig module about the spotlight product itself is hidden (the card above covers it);
     - the "Complete your haul" rail skips the spotlight product and anything those modules show;
     - category tabs move products already shown above to the end of the tab (tabs stay complete);
     - add-on and gift lists hide already-shown products, and their "load more" skips them (Shop All stays complete).
     Look-alike listings (hero setting "Look-alike products") count as one product. */
  var twins = null;
  var pageSeen = null;

  function canon(h) {
    if (!twins) {
      twins = {};
      var src = document.querySelector('[data-ph26-twins]');
      (src ? src.getAttribute('data-ph26-twins') : '').split(/\r?\n/).forEach(function (line) {
        var hs = line.split(',').map(function (x) { return x.trim().toLowerCase(); }).filter(Boolean);
        hs.forEach(function (x) { twins[x] = hs[0]; });
      });
    }
    h = String(h || '').toLowerCase();
    return twins[h] || h;
  }

  function isSeen(h) { return !!(pageSeen && pageSeen[canon(h)]); }

  function moduleHandle(el) {
    var a = el.querySelector('a[href*="/products/"]');
    return a ? a.getAttribute('href').split('/products/')[1].split(/[?#/]/)[0] : '';
  }

  function hideItem(li) { li.style.display = 'none'; li.setAttribute('data-ph26-dupe', ''); }

  function dedupePage() {
    if (pageSeen) return;
    var seen = {};
    var claimed = {};
    var focusCard = document.querySelector('.ph26 [data-ph26-focus]:not([hidden]) [data-ph26-focus-card]');
    var focusKey = focusCard ? canon(focusCard.getAttribute('data-handle')) : '';
    var markIn = function (scope, into) {
      scope.querySelectorAll('[data-ph26-card]').forEach(function (c) {
        var li = c.closest('li');
        if (c.offsetParent !== null && !(li && li.hasAttribute('data-ph26-dupe'))) into[canon(c.getAttribute('data-handle'))] = true;
      });
    };

    // 1. Feature modules.
    document.querySelectorAll('.ph26-rider, .ph26-wig').forEach(function (m) {
      var k = canon(moduleHandle(m));
      if (!k) return;
      if (focusKey && k === focusKey) { var sec = m.closest('.shopify-section') || m; sec.style.display = 'none'; return; }
      if (m.offsetParent !== null) claimed[k] = true;
    });
    document.querySelectorAll('.ph26-wanted, .ph26-pam').forEach(function (m) { markIn(m, claimed); });

    // 2. Spotlight card + haul rail.
    if (focusKey) seen[focusKey] = true;
    var haul = document.querySelector('[data-ph26-haul]');
    if (haul) {
      haul.querySelectorAll('.ph26-addons__item').forEach(function (li) {
        var k = canon(li.querySelector('[data-ph26-card]') && li.querySelector('[data-ph26-card]').getAttribute('data-handle'));
        if (k && (k === focusKey || claimed[k] || seen[k])) hideItem(li); else if (k) seen[k] = true;
      });
    }
    Object.keys(claimed).forEach(function (k) { seen[k] = true; });

    // 3. Category tabs, in page order (open or not — shoppers open several): products already shown above are hidden
    //    when the tab still keeps at least 3 new ones (count badge updated); otherwise they only move to the end, so a
    //    tab is never emptied. A look-alike of a product earlier in the same tab counts as shown.
    //    Only tabs open by default count as "shown" for the lists further down; all tabs count for later tabs.
    var inTabs = {};
    document.querySelectorAll('.ph26-shop-group').forEach(function (g) {
      var ul = g.querySelector('.ph26-shop-grid');
      if (!ul) return;
      var fresh = [], shownBefore = [], inTab = {};
      Array.prototype.forEach.call(ul.children, function (li) {
        var c = li.querySelector('[data-ph26-card]');
        var k = c ? canon(c.getAttribute('data-handle')) : '';
        if (k && (seen[k] || inTabs[k] || inTab[k])) shownBefore.push(li); else { fresh.push(li); if (k) inTab[k] = true; }
      });
      if (shownBefore.length && fresh.length >= 3) {
        shownBefore.forEach(hideItem);
        ul.setAttribute('data-count', fresh.length); // grid column rules key off the item count
        var badge = g.querySelector('.ph26-shop-count');
        if (badge) badge.textContent = fresh.length;
      } else if (shownBefore.length && fresh.length) {
        fresh.concat(shownBefore).forEach(function (li) { ul.appendChild(li); });
      }
      Object.keys(inTab).forEach(function (k) { inTabs[k] = true; if (g.open) seen[k] = true; });
    });

    // 4. Add-on and gift lists (the haul rail is handled above): hide what is already on screen above, keeping at
    //    least 3 items in a list without "load more" (gifts); add-ons top up from their collection instead.
    document.querySelectorAll('.ph26-addons:not(.ph26-haul) .ph26-addons__rail, .ph26-gifts__list').forEach(function (list) {
      var block = list.closest('.ph26-addons, .ph26-gifts');
      if (block && block.offsetParent === null) return; // list not on screen (e.g. add-ons in spotlight mode)
      var items = Array.prototype.filter.call(list.children, function (li) { return li.querySelector('[data-ph26-card]'); });
      var dupes = items.filter(function (li) { return seen[canon(li.querySelector('[data-ph26-card]').getAttribute('data-handle'))]; });
      var canTopUp = list.hasAttribute('data-ph26-feed');
      if (dupes.length && (canTopUp || items.length - dupes.length >= 3)) dupes.forEach(hideItem);
      else if (dupes.length) items.filter(function (li) { return dupes.indexOf(li) < 0; }).concat(dupes).forEach(function (li) { list.appendChild(li); });
      items.forEach(function (li) { if (!li.hasAttribute('data-ph26-dupe')) seen[canon(li.querySelector('[data-ph26-card]').getAttribute('data-handle'))] = true; });
    });
    Object.keys(inTabs).forEach(function (k) { if (!seen[k]) seen[k] = 'tab'; });
    pageSeen = seen;

    // Lists that lost items: top them up from their collection with products not shown yet.
    document.querySelectorAll('.ph26-addons:not(.ph26-haul) .ph26-addons__rail[data-ph26-feed]').forEach(function (list) {
      if (list.offsetParent !== null && list.querySelector('[data-ph26-dupe]')) feedFor(list).more().then(function () { var r = list.closest('[data-ph26-rail]'); if (r) railUpdate(r); });
    });
    document.querySelectorAll('.ph26 [data-ph26-rail]').forEach(railUpdate);
  }

  /* ---------- Ad spotlight: "Complete your haul" (rail + live 3-item progress under the spotlight card) ----------
     Offer data (percentage, code, end) comes from the Multi-buy section's haul bar, so it always matches the banner.
     Counting follows the same eligibility rule as the haul bar. */
  var haulAddedUntil = 0;

  function haulOffer() {
    var bar = document.querySelector('[data-ph26-progress]');
    if (!bar) return null;
    var p3 = bar.getAttribute('data-p3');
    var end = Date.parse(bar.getAttribute('data-offer-end') || '');
    if (!p3 || (!isNaN(end) && Date.now() >= end)) return null;
    return { pct: p3, code: bar.getAttribute('data-code') || '' };
  }

  function updateHaul(cart) {
    var haul = document.querySelector('[data-ph26-haul]');
    if (!haul) return;
    var status = haul.querySelector('[data-ph26-haul-status]');
    var offer = haulOffer();
    if (!offer) { status.hidden = true; return; }
    var ids = eligibleIds();
    var count = 0;
    ((cart && cart.items) || []).forEach(function (it) { if (!ids || ids[it.product_id]) count += it.quantity; });
    var left = Math.max(0, 3 - count);
    var codeTxt = offer.code ? ' with code ' + offer.code : '';
    var text;
    if (count <= 0) text = 'Buy any 3 items, save ' + offer.pct + '%' + codeTxt;
    else if (left > 0) text = count + ' in your cart — add ' + left + ' more to save ' + offer.pct + '%';
    else text = offer.pct + '% off unlocked — enter ' + (offer.code || 'the code') + ' at checkout';
    if (Date.now() < haulAddedUntil) text = 'Added ✓ · ' + text;
    haul.querySelector('[data-ph26-haul-text]').textContent = text;
    haul.querySelectorAll('.ph26-haul__steps li').forEach(function (li, i) { li.classList.toggle('is-on', i < count); });
    var done = haul.querySelector('[data-ph26-haul-done]');
    var copy = done.querySelector('[data-ph26-copy]');
    if (offer.code) copy.setAttribute('data-ph26-copy', offer.code); else copy.hidden = true;
    done.hidden = left > 0;
    status.classList.toggle('is-done', left === 0);
    status.classList.toggle('is-empty', count <= 0); // phones hide it until the first add (the card shows the offer)
    status.hidden = false;
  }

  // Rebuy Smart Cart opens itself on every cart change. For adds made in the spotlight flow we keep the shopper on
  // the page: while a "quiet" window is open (from the add click until shortly after), a drawer that pops up is
  // closed again. Clicking the cart icon, the haul bar's cart button or anything in the drawer ends the window.
  var haulQuietUntil = 0;
  var haulQuietObserver = null;

  function haulQuiet(ms) {
    haulQuietUntil = Math.max(haulQuietUntil, Date.now() + ms);
    if (haulQuietObserver || !('MutationObserver' in window)) return;
    haulQuietObserver = new MutationObserver(function () {
      if (Date.now() >= haulQuietUntil || !document.body.classList.contains('rebuy-cart-visible')) return;
      try { window.Rebuy.SmartCart.hide(); } catch (e) {}
    });
    haulQuietObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    if (t.closest('#cart-icon-bubble, [data-ph26-cart-open], .rebuy-cart__flyout, .rebuy-cart')) { haulQuietUntil = 0; return; }
    var inFocus = t.closest('[data-ph26-focus] [data-ph26-add], [data-ph26-focus] [data-ph26-pick]');
    var sheetAdd = t.closest('[data-ph26-sheet-add]') && sheetTrigger && sheetTrigger.closest && sheetTrigger.closest('[data-ph26-focus]');
    if (inFocus || sheetAdd) haulQuiet(8000);
  }, true);

  // Spotlight add: refresh the cart icon (no drawer), confirm in the haul, and bring the rail into view.
  function haulAdded(origin) {
    haulQuiet(3000);
    haulAddedUntil = Date.now() + 2500;
    refreshCartUi(false);
    setTimeout(fetchCartCount, 2600);
    var haul = document.querySelector('[data-ph26-haul]');
    if (!haul) return;
    var status = haul.querySelector('[data-ph26-haul-status]');
    status.classList.remove('is-flash');
    void status.offsetWidth;
    status.classList.add('is-flash');
    var head = haul.querySelector('.ph26-haul__head');
    var r = head.getBoundingClientRect();
    if (origin.closest('[data-ph26-focus-card]') && (r.top > window.innerHeight - 120 || r.bottom < 0)) {
      head.scrollIntoView({ block: 'start', behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    }
  }

  function mountHaul(box, handle) {
    var tpl = box.querySelector('template[data-ph26-haul-tpl]');
    if (!tpl || box.querySelector('[data-ph26-haul]')) return;
    var frag = tpl.content.cloneNode(true);
    // Skip the spotlight product in the rail (kept hidden so "load more" does not add it back).
    frag.querySelectorAll('[data-ph26-card][data-handle="' + handle + '"]').forEach(function (c) {
      var li = c.closest('li');
      if (li) li.style.display = 'none';
    });
    box.appendChild(frag);
    var haul = box.querySelector('[data-ph26-haul]');
    upgradeCards(haul);
    // The rail peeks into the first screen: show its cards at once (no scroll fade) and load the first photos now.
    haul.querySelectorAll('[data-ph26-reveal]').forEach(function (el) { el.classList.add('is-in'); });
    Array.prototype.slice.call(haul.querySelectorAll('.ph26-addons__item')).filter(function (li) { return li.style.display !== 'none'; })
      .slice(0, 4).forEach(function (li) { li.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; }); });
    initRails(haul);
    fetchCartCount();
  }

  /* ---------- Ad spotlight: ?focus=<product-handle> puts that product above the hero ----------
     The inline script in ph26-hero.liquid has already validated the handle and reserved the space.
     The card is rendered by sections/ph26-focus.liquid in the product's own context (any published product,
     on this page or not; market prices). Buying goes through the page's existing Quick Add / picker /
     Personalize hooks. The discount strip is copied from the multi-buy banner, so it shows the same code and
     disappears with it when the offer ends. Any failure (unknown handle, sold out, not sold in this market,
     slow network) removes the box and leaves the page exactly as without the parameter. */
  function focusOffer(card) {
    var slot = card.querySelector('[data-ph26-focus-offer]');
    var mb = document.querySelector('.ph26-multibuy');
    var code = mb && mb.querySelector('.ph26-multibuy__code');
    if (!slot || !code || mb.hidden) return;
    var qty = mb.querySelector('.ph26-multibuy__tier--hot .ph26-multibuy__qty');
    var save = mb.querySelector('.ph26-multibuy__tier--hot .ph26-multibuy__save');
    var note = mb.querySelector('.ph26-multibuy__copy p');
    var html = '';
    // Phones fold the end date into this line (the strip's own end line is hidden there to save height).
    var endsEl = code.querySelector('.ph26-multibuy__ends');
    var endsShort = endsEl ? endsEl.textContent.trim().split(',')[0] : '';
    if (qty && save) html += '<p class="ph26-focus__deal">Buy ' + esc(qty.textContent.trim()) + ', ' + esc(save.textContent.trim().toLowerCase()) +
      (endsShort ? '<span class="ph26-focus__deal-end"> · ' + esc(endsShort) + '</span>' : '') + '</p>';
    if (note) html += '<p class="ph26-focus__deal-note">' + esc(note.textContent.trim()) + '</p>';
    slot.innerHTML = html;
    var strip = code.cloneNode(true);
    var status = strip.querySelector('[data-ph26-copy-status]');
    if (status) status.textContent = '';
    slot.appendChild(strip);
    var ends = mb.getAttribute('data-ph26-expires');
    if (ends) slot.setAttribute('data-ph26-expires', ends);
    slot.hidden = false;
  }

  function focusShow(card, n) {
    var img = card.querySelector('[data-ph26-focus-img="' + n + '"]');
    if (!img) return;
    card.querySelectorAll('[data-ph26-focus-img]').forEach(function (el) { el.classList.toggle('is-on', el === img); });
    img.loading = 'eager';
    // Phones: the photos are a swipe row — scroll to the chosen one.
    var main = card.querySelector('[data-ph26-focus-main]');
    if (main && main.scrollWidth > main.clientWidth + 2) main.scrollLeft = (parseInt(n, 10) - 1) * main.clientWidth;
    card.querySelectorAll('[data-ph26-focus-thumb]').forEach(function (t) {
      var on = t.getAttribute('data-ph26-focus-thumb') === String(n);
      t.classList.toggle('is-on', on);
      if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
    });
  }

  // Swipe row (phones): keep the "n / total" badge in step with the visible photo.
  function initFocusSwipe(card) {
    var main = card.querySelector('[data-ph26-focus-main]');
    var count = card.querySelector('[data-ph26-focus-count]');
    if (!main || !count) return;
    var total = card.querySelectorAll('[data-ph26-focus-img]').length;
    var t = 0;
    main.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var i = Math.min(total, Math.round(main.scrollLeft / (main.clientWidth || 1)) + 1);
        count.textContent = i + ' / ' + total;
      }, 60);
    }, { passive: true });
  }

  function initProductFocus() {
    var box = document.querySelector('.ph26 [data-ph26-focus][aria-busy="true"]');
    if (!box || box.ph26Focus) return;
    box.ph26Focus = true;
    var handle = box.getAttribute('data-ph26-focus');
    var slot = box.querySelector('[data-ph26-focus-slot]');
    function fail() {
      box.hidden = true;
      box.removeAttribute('aria-busy');
      root.classList.remove('ph26-focus-on');
      setHeroOffset();
      dedupePage();
    }
    var ctrl = window.AbortController ? new AbortController() : null;
    var timer = setTimeout(function () { if (ctrl) ctrl.abort(); fail(); }, 8000);
    fetch(root_url + 'products/' + encodeURIComponent(handle) + '?section_id=ph26-focus', {
      credentials: 'same-origin',
      signal: ctrl ? ctrl.signal : undefined
    })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        clearTimeout(timer);
        if (!box.hasAttribute('aria-busy')) return; // already timed out
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var card = tmp.querySelector('[data-ph26-focus-card]');
        if (!card) throw new Error('unavailable');
        slot.innerHTML = '';
        slot.appendChild(card);
        box.removeAttribute('aria-busy');
        focusOffer(card);
        initFocusSwipe(card);
        var n = parseInt(new URLSearchParams(window.location.search).get('fimg'), 10);
        if (n > 1) focusShow(card, n);
        mountHaul(box, handle);
        dedupePage();
        upgradeCards(box);
        // Globo's option map can arrive after us: re-check the card once everything has loaded.
        window.addEventListener('load', function () {
          box.querySelectorAll('[data-ph26-card]').forEach(function (c) { c.removeAttribute('data-ph26-checked'); });
          upgradeCards(box);
        });
        setHeroOffset();
        document.dispatchEvent(new CustomEvent('ph26:focus-shown', { detail: { handle: handle, productId: card.getAttribute('data-pid') } }));
      })
      .catch(function () { clearTimeout(timer); fail(); });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('.ph26 [data-ph26-focus-thumb]');
    if (t) focusShow(t.closest('[data-ph26-focus-card]'), t.getAttribute('data-ph26-focus-thumb'));
  });

  /* ---------- Bats: natural flight ----------
     Each flight is a random cubic Bézier through the free area of its section (measured from the real text
     boxes at the start of every flight, so bats never cross copy or buttons), with speed variation,
     a small flutter, banking into turns, gliding on descents and per-bat wing-beat rates.
     Runs only while the section is on screen and the tab is visible; disabled for reduced motion. */
  var DESKTOP_ART = window.matchMedia('(min-width: 990px), (min-width: 750px) and (orientation: landscape)');

  function rnd(a, b) { return a + Math.random() * (b - a); }

  function relRects(sky, nodes) {
    var base = sky.getBoundingClientRect();
    return Array.prototype.map.call(nodes, function (n) {
      var r = n.getBoundingClientRect();
      return { l: r.left - base.left, t: r.top - base.top, r: r.right - base.left, b: r.bottom - base.top };
    }).filter(function (r) { return r.r > r.l && r.b > r.t; });
  }

  // Returns the free rectangle bats may use: {x0,x1,y0,y1,mode:'side'|'band'} or null.
  function freeZone(sky) {
    var W = sky.clientWidth, H = sky.clientHeight;
    var kind = sky.getAttribute('data-ph26-sky');
    var section = sky.closest('.ph26');
    var items, rects, m = 22;
    if (kind === 'hero') {
      items = section.querySelectorAll('.ph26-hero__top > *, .ph26-hero__bottom > *');
      rects = relRects(sky, items);
      if (!rects.length) return { x0: -60, x1: W + 60, y0: 40, y1: H * 0.8, mode: 'band' };
      if (DESKTOP_ART.matches) {
        var right = Math.max.apply(null, rects.map(function (r) { return r.r; }));
        if (W - right > 220) return { x0: right + 70, x1: W + 70, y0: 36, y1: H * 0.82, mode: 'side' };
      }
      var top = section.querySelectorAll('.ph26-hero__top > *');
      var bottom = section.querySelectorAll('.ph26-hero__bottom > *');
      var tb = relRects(sky, top), bb = relRects(sky, bottom);
      var y0 = tb.length ? Math.max.apply(null, tb.map(function (r) { return r.b; })) + m : 40;
      var y1 = bb.length ? Math.min.apply(null, bb.map(function (r) { return r.t; })) - m : H - 40;
      return y1 - y0 > 70 ? { x0: -60, x1: W + 60, y0: y0, y1: y1, mode: 'band' } : null;
    }
    // closing: prefer the band below the content, else the band above it (under the lights)
    items = section.querySelectorAll('.ph26-closing__content > *');
    rects = relRects(sky, items);
    if (!rects.length) return { x0: -60, x1: W + 60, y0: 60, y1: H - 40, mode: 'band' };
    var cTop = Math.min.apply(null, rects.map(function (r) { return r.t; }));
    var cBot = Math.max.apply(null, rects.map(function (r) { return r.b; }));
    if (H - 30 - (cBot + m) > 80) return { x0: -60, x1: W + 60, y0: cBot + m, y1: H - 30, mode: 'band' };
    if (cTop - m - 56 > 70) return { x0: -60, x1: W + 60, y0: 56, y1: cTop - m, mode: 'band' };
    return null;
  }

  function planFlight(z, W) {
    var P;
    if (z.mode === 'side') {
      // Enter from the right edge, swoop through the free side, exit right or up behind the header.
      var y = rnd(z.y0 + 20, z.y0 + (z.y1 - z.y0) * 0.7);
      var exitUp = Math.random() < 0.45;
      P = [
        { x: W + 60, y: y },
        { x: rnd(z.x0, z.x0 + (W - z.x0) * 0.45), y: rnd(z.y0, z.y1) },
        { x: rnd(z.x0, W), y: rnd(z.y0, z.y1) },
        exitUp ? { x: rnd(z.x0 + (W - z.x0) * 0.4, W), y: -60 } : { x: W + 60, y: rnd(z.y0, z.y1) }
      ];
    } else {
      var ltr = Math.random() < 0.5;
      var sx = ltr ? -60 : W + 60, ex = ltr ? W + 60 : -60;
      var pad = Math.min(18, (z.y1 - z.y0) / 4);
      P = [
        { x: sx, y: rnd(z.y0 + pad, z.y1 - pad) },
        { x: W * rnd(0.2, 0.45), y: rnd(z.y0 + pad, z.y1 - pad) },
        { x: W * rnd(0.55, 0.8), y: rnd(z.y0 + pad, z.y1 - pad) },
        { x: ex, y: rnd(z.y0 + pad, z.y1 - pad) }
      ];
    }
    return P;
  }

  function bez(P, t) {
    var u = 1 - t;
    var a = u * u * u, b = 3 * u * u * t, c = 3 * u * t * t, d = t * t * t;
    return { x: a * P[0].x + b * P[1].x + c * P[2].x + d * P[3].x, y: a * P[0].y + b * P[1].y + c * P[2].y + d * P[3].y };
  }

  function bezD(P, t) {
    var u = 1 - t;
    return {
      x: 3 * u * u * (P[1].x - P[0].x) + 6 * u * t * (P[2].x - P[1].x) + 3 * t * t * (P[3].x - P[2].x),
      y: 3 * u * u * (P[1].y - P[0].y) + 6 * u * t * (P[2].y - P[1].y) + 3 * t * t * (P[3].y - P[2].y)
    };
  }

  function Sky(el) {
    this.el = el;
    this.visible = false;
    this.raf = 0;
    var now = performance.now();
    this.bats = Array.prototype.map.call(el.querySelectorAll('.ph26-batwrap'), function (w, i) {
      var depth = parseFloat(w.getAttribute('data-depth')) || 1;
      w.style.setProperty('--depth', depth);
      w.style.setProperty('--flap', rnd(0.24, 0.34).toFixed(3) + 's');
      return { el: w, depth: depth, flight: null, next: now + rnd(800, 2600) + i * rnd(1800, 3200) };
    });
    this.tick = this.tick.bind(this);
  }

  Sky.prototype.start = function (bat, now, follow) {
    var W = this.el.clientWidth;
    var z = freeZone(this.el);
    if (!z) { bat.next = now + 4000; return; }
    var P = follow ? follow.P.map(function (p) { return { x: p.x + rnd(-24, 24), y: p.y + rnd(18, 34) }; }) : planFlight(z, W);
    if (follow) { // keep the follower inside the same free zone
      P.forEach(function (p) { p.y = Math.min(Math.max(p.y, z.y0 + 8), Math.max(z.y1 - 8, z.y0 + 8)); });
    }
    var len = 0, prev = P[0];
    for (var k = 1; k <= 12; k++) { var q = bez(P, k / 12); len += Math.hypot(q.x - prev.x, q.y - prev.y); prev = q; }
    var speed = rnd(190, 300) * (0.65 + 0.35 * bat.depth);
    var amp = Math.min(rnd(5, 11) * bat.depth, z.mode === 'band' ? (z.y1 - z.y0) / 5 : 12);
    bat.flight = { P: P, t0: now + (follow ? rnd(220, 480) : 0), dur: (len / speed) * 1000, amp: amp, freq: rnd(1.4, 2.4), ph: rnd(0, 6.28), zone: z };
    bat.el.classList.remove('is-gliding');
  };

  Sky.prototype.tick = function (now) {
    var self = this;
    self.raf = 0;
    if (!self.visible || document.hidden) return;
    self.bats.forEach(function (bat, i) {
      var f = bat.flight;
      if (!f) {
        if (now >= bat.next) {
          self.start(bat, now);
          // Sometimes a smaller bat tags along.
          var mate = self.bats[(i + 1) % self.bats.length];
          if (mate !== bat && !mate.flight && Math.random() < 0.35) self.start(mate, now, bat.flight);
        }
        return;
      }
      var t = (now - f.t0) / f.dur;
      if (t < 0) return;
      if (t >= 1) {
        bat.flight = null;
        bat.el.classList.remove('is-flying', 'is-gliding');
        bat.next = now + rnd(5000, 12000);
        return;
      }
      // Ease the speed a little: bats slow into turns and burst out of them.
      var te = t + 0.06 * Math.sin(t * Math.PI * 2);
      var p = bez(f.P, te), d = bezD(f.P, te);
      var v = Math.hypot(d.x, d.y) || 1;
      var nx = -d.y / v, ny = d.x / v;
      var secs = (now - f.t0) / 1000;
      var wob = f.amp * Math.sin(secs * f.freq * Math.PI * 2 + f.ph);
      var x = p.x + nx * wob, y = p.y + ny * wob;
      if (f.zone.mode === 'band') y = Math.min(Math.max(y, f.zone.y0), f.zone.y1);
      var climb = d.y / v; // <0 climbing, >0 diving
      var bank = Math.max(-28, Math.min(28, climb * 34 * (d.x < 0 ? -1 : 1) + wob * 0.8));
      bat.el.classList.add('is-flying');
      bat.el.classList.toggle('is-gliding', climb > 0.32);
      bat.el.style.transform = 'translate3d(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px,0) rotate(' + bank.toFixed(1) + 'deg)';
    });
    self.raf = requestAnimationFrame(self.tick);
  };

  Sky.prototype.wake = function () {
    if (!this.raf && this.visible && !document.hidden) this.raf = requestAnimationFrame(this.tick);
  };

  var skies = [];

  function initSkies(scope) {
    if (reduceMotion.matches || !('IntersectionObserver' in window)) return;
    (scope || document).querySelectorAll('.ph26 [data-ph26-sky]').forEach(function (el) {
      if (el.ph26Sky) return;
      var sky = new Sky(el);
      el.ph26Sky = sky;
      skies.push(sky);
      new IntersectionObserver(function (entries) {
        sky.visible = entries[0].isIntersecting;
        sky.wake();
      }).observe(el);
    });
  }

  document.addEventListener('visibilitychange', function () {
    skies.forEach(function (s) { s.wake(); });
  });

  /* ---------- Page chrome: official transparent white logo in header + footer (this page only) ---------- */
  function swapLogos() {
    if (!logoUrl) return;
    document.querySelectorAll('.section-header .header__heading-logo, .footer .footer-block__image-wrapper img').forEach(function (img) {
      if (img.getAttribute('data-ph26-logo-done')) return;
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = logoUrl;
      img.setAttribute('data-ph26-logo-done', '1');
    });
  }

  /* ---------- Offer end: hide expiring elements live (server hides them too after the time) ---------- */
  function applyExpiry() {
    var now = Date.now(), next = Infinity;
    document.querySelectorAll('.ph26 [data-ph26-expires], .ph26[data-ph26-expires]').forEach(function (el) {
      var t = Date.parse(el.getAttribute('data-ph26-expires'));
      if (isNaN(t)) return;
      if (now >= t) el.hidden = true; else next = Math.min(next, t);
    });
    document.querySelectorAll('[data-ph26-offer-top]').forEach(function (top) {
      var t = Date.parse(top.getAttribute('data-ph26-offer-end'));
      if (!isNaN(t) && now >= t) top.classList.remove('ph26-hero__top--offer');
    });
    if (next !== Infinity && next - now < 2147483000) setTimeout(function () { applyExpiry(); fetchCartCount(); }, next - now + 50);
  }

  /* ---------- Copy discount code ---------- */
  function legacyCopy(text) {
    return new Promise(function (resolve, reject) {
      var ta = document.createElement('textarea');
      ta.value = text; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.top = '0'; ta.style.opacity = '0';
      document.body.appendChild(ta); ta.select(); ta.setSelectionRange(0, text.length);
      var ok = false;
      try { ok = document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(ta);
      ok ? resolve() : reject(new Error('copy failed'));
    });
  }

  // Async Clipboard API first; if it is unavailable or refused (some in-app browsers), fall back to execCommand.
  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text).catch(function () { return legacyCopy(text); });
    }
    return legacyCopy(text);
  }

  function onCopyClick(e) {
    var btn = e.target.closest('.ph26 [data-ph26-copy]');
    if (!btn) return;
    var code = btn.getAttribute('data-ph26-copy');
    var label = btn.getAttribute('data-label') || btn.textContent;
    btn.setAttribute('data-label', label);
    var status = btn.parentElement.querySelector('[data-ph26-copy-status]');
    copyText(code).then(function () {
      btn.textContent = 'Copied ✓';
      btn.classList.add('is-copied');
      if (status) status.textContent = 'Code ' + code + ' copied. Paste it at checkout.';
    }, function () {
      // Clipboard blocked: select the code so it can be copied manually.
      var val = btn.parentElement.querySelector('.ph26-multibuy__code-value');
      if (val && window.getSelection) { var r = document.createRange(); r.selectNodeContents(val); var s = window.getSelection(); s.removeAllRanges(); s.addRange(r); }
      btn.textContent = 'Press and hold to copy';
    }).finally(function () {
      clearTimeout(btn.ph26CopyTimer);
      btn.ph26CopyTimer = setTimeout(function () { btn.textContent = label; btn.classList.remove('is-copied'); }, 2500);
    });
  }
  document.addEventListener('click', onCopyClick);

  function init(scope) {
    applyExpiry();
    swapLogos();
    setHeroOffset();
    scheduleCountdown();
    upgradeCards(scope);
    initReveal(scope);
    initRails(scope);
    initProgress();
    initFocus();
    initProductFocus();
    // Without a pending spotlight, de-duplicate right away (with one, it runs once the spotlight settles).
    if (!document.querySelector('.ph26 [data-ph26-focus][aria-busy="true"]')) dedupePage();
    initSkies(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  window.addEventListener('resize', setHeroOffset, { passive: true });
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) scheduleCountdown();
  });

  /* Theme editor: re-run when a section is added or re-rendered. */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

(function () {
  if (window.ph26CatalogLoaded) return;
  window.ph26CatalogLoaded = true;
  function reveal(hash, scroll) {
    if (!hash || hash.charAt(0) !== '#') return;
    var target = document.getElementById(hash.slice(1));
    if (!target || !target.classList.contains('ph26-shop-group')) return;
    document.querySelectorAll('.ph26-shop-group').forEach(function (group) { group.open = group === target; });
    target.querySelectorAll('img[loading]').forEach(function (img) { img.loading = 'eager'; });
    target.querySelectorAll('[data-ph26-reveal]').forEach(function (el) { el.classList.add('is-in'); });
    if (scroll) requestAnimationFrame(function () { target.scrollIntoView({block:'start',behavior:'auto'}); });
  }
  document.addEventListener('click', function (event) {
    var link = event.target.closest('.ph26 a[href^="#"]');
    if (link) reveal(link.getAttribute('href'), false);
  });
  document.addEventListener('toggle', function (event) {
    if (!event.target.matches('.ph26-shop-group[open]')) return;
    event.target.querySelectorAll('img[loading]').forEach(function (img) { img.loading = 'eager'; });
    event.target.querySelectorAll('[data-ph26-reveal]').forEach(function (el) { el.classList.add('is-in'); });
  }, true);
  window.addEventListener('hashchange', function () { reveal(location.hash, true); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { reveal(location.hash, true); });
  else reveal(location.hash, true);
})();
